// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_b6bb40a","returns":"_e54d239","value":"_5af4800","bonusCash":"_0d67eae","returnValuePriceChange":"_6f62cf5","returnValue":"_325d9eb"};